// #648: envelope returned by all paged BFF browse-list endpoints, and the
// query parameters they accept (skip default 0, take default 50 / max 500,
// sortBy from a per-endpoint whitelist).
export interface PagedResult<T> {
  items: T[];
  totalCount: number;
}

export interface PagingParams {
  skip?: number;
  take?: number;
  sortBy?: string;
  sortDescending?: boolean;
}

/**
 * Spreads paging into an HttpClient params object literal. Only defined keys
 * are emitted — HttpClient stringifies undefined values to the literal
 * string "undefined".
 */
export function pagingToHttpParams(paging?: PagingParams): Record<string, string | number | boolean> {
  const params: Record<string, string | number | boolean> = {};
  if (!paging) {
    return params;
  }
  if (paging.skip !== undefined) {
    params['skip'] = paging.skip;
  }
  if (paging.take !== undefined) {
    params['take'] = paging.take;
  }
  if (paging.sortBy !== undefined) {
    params['sortBy'] = paging.sortBy;
    params['sortDescending'] = paging.sortDescending === true;
  }
  return params;
}
